import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAttrs, computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBarButton',
  props: {
  icon: { type: String, required: true },
},
  setup(__props) {



const attrs = useAttrs();
const tag = computed<"a" | "button">(() => {
  return attrs.href ? "a" : "button";
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), _mergeProps({ class: "btn top-bar-btn" }, _ctx.$attrs, _toHandlers(_ctx.$attrs)), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_component_font_awesome_icon, { icon: __props.icon }, null, 8, ["icon"])
      ])
    ]),
    _: 3
  }, 16))
}
}

})